import { Base } from './base.resource';


/**
 * Program Place Period interface
 * @export
 * @interface jsonOffer
 */
export interface JsonProgramPlacePeriod {
    id: number;
    start_time: string;
    end_time: string;
    program_id: number;
    channel_id?: string;
    area_id?: string;
    max_number_of_advertiser: number;
}

/**
 * Program Place Period interface
 * @export
 * @class ProgramPlacePeriod
 * @extends {Base}
 */
export class ProgramPlacePeriod extends Base {

    static init(): JsonProgramPlacePeriod {
        return {
            id: null,
            start_time: 'du',
            end_time: 'au',
            program_id: null,
            channel_id: null,
            area_id: null,
            max_number_of_advertiser: 0
        };
    }

    public id: number;
    public startTime: string;
    public endTime: string;
    public programId: number;
    public channelId: string;
    public areaId: string;
    public maxNumberOfAdvertiser: number;

    constructor(jsonProgramPlacePeriod) {
        super();
        jsonProgramPlacePeriod = this.convertToUnderscore(jsonProgramPlacePeriod);

        this.id = jsonProgramPlacePeriod.id;
        this.startTime = jsonProgramPlacePeriod.start_time;
        this.endTime = jsonProgramPlacePeriod.end_time;
        this.programId = jsonProgramPlacePeriod.program_id;
        this.channelId = jsonProgramPlacePeriod.channel_id;
        this.areaId = jsonProgramPlacePeriod.area_id;
        this.maxNumberOfAdvertiser = jsonProgramPlacePeriod.max_number_of_advertiser;
    }
}
